<div class="w-full h-full flex items-center justify-center rounded-full text-white font-bold uppercase overflow-hidden"
    [ngClass]="[backgroundColor, textColor]">
    <img *ngIf="imageUrl" [src]="imageUrl" alt="{{ 'shared.components.user_avatar' | transloco }}" (error)="imageUrl = null" class="w-full h-full object-cover rounded-full" />
    <span *ngIf="!imageUrl" class="font-normal mobile:text-base" [ngClass]="[textSize]">{{ initials }}</span>
</div>